(function($){
  function showProductPurchaseModal(e){
    e.preventDefault();
    $('.product-main-container').addClass('modal-active');
    $('.product-modal-backdrop').addClass('active');
  }

  function hideProductPurchaseModal(e){
    e.preventDefault();
    jQuery('.product-main-container').removeClass('modal-active');
    jQuery('.product-modal-backdrop').removeClass('active');
  }

  function toggleContentGrid(e){
    e.preventDefault();
    $('.row-more-content').slideToggle('fast');
    $(this).toggleClass('expanded');
  }

  function toggleKnowledgeBoxModal(e){
    e.preventDefault();

    var title = $(this).find('.knowledge-box__title').html();
    var content = $(this).find('.knowledge-box__content').html();

    $('.knowledge-box__modal-title').html(title);
    $('.knowledge-box__modal-content').html(content);
    //$('.product-modal-backdrop').addClass('active');
    $('.knowledge-box__modal').addClass('active');
    $('.knowledge-box__modal-container').addClass('active');
    $('body').css('overflow', 'hidden');
  }

  function closeKnowledgeBoxModal(e){
    e.preventDefault();

    $('.product-modal-backdrop').removeClass('active');
    $('.knowledge-box__modal').removeClass('active');
    $('.knowledge-box__modal-container').removeClass('active');
    $('body').css('overflow', 'auto');
  }

  $(document).ready(function(){
    $('.benefits-buy-now, .ora-floating-atc-button').on('click', showProductPurchaseModal);
    $('.product-close-modal').on('click', hideProductPurchaseModal);
    $('.content-grid__expand-button').on('click', toggleContentGrid);
    $('.knowledge-box').on('click', toggleKnowledgeBoxModal);
    $('.knowledge-box__modal-close, .product-modal-backdrop').on('click', closeKnowledgeBoxModal);

    $('.knowledge-box__modal-container').on('click', function(e){
      e.stopPropagation();

      if ($(e.target).closest('.knowledge-box__modal').length) {
        return;
      }

      $('.knowledge-box__modal-container').removeClass('active');
      $('body').css('overflow', 'auto');

    });
  });
})(jQuery);